
export default node => ({
  language: getLang(node),
  altUrls: getAltUrls(node),
  seoProps: getSeoProps(node)
})

const getLang = ({ lang } = {}) => (
  lang ? lang.substring(0, 2) : null
)

const getAltUrls = (node = {}) => {
  const {
    alternate_languages: altLangs = [],
    url
  } = node
  const currentLang = getLang(node)

  const altUrlCurrent = { url, lang: currentLang }

  const altUrlOthers = altLangs
    ? altLangs.map(({ document }) => document)
    : []

  return [
    altUrlCurrent,
    ...altUrlOthers
  ]
}

export const getSeoProps = (node = {}) => {
  if (!node.data || !node.data.seo_properties) {
    return null
  }

  const properties = node.data.seo_properties

  return properties
    .filter(({ type }) => type !== null)
    .reduce((acc, { type, value }) => {
      if (type === 'title') {
        acc.title = value
      } else if (type.match(/^og:/)) {
        acc.og = { ...(acc.og || {}), [type]: value }
      } else {
        acc.meta = { ...(acc.meta || {}), [type]: value }
      }
      return acc
    }, {})
}